"use client"

import { motion } from "framer-motion";
import { Shield, Target } from "lucide-react";
import { Products } from "@/types/productsTypes";

export function MitreMatrix({ section }: { section: Products["atlasai"]["mitre"] }) {
    return (
        <section className="section-bg-darker rounded-[32px] px-8 py-24">
            <div className="max-w-6xl mx-auto space-y-12">
                <div className="text-center space-y-4">
                    <span className="section-badge badge-size inline-block w-fit">
                        {section.badge}
                    </span>
                    <h2 className="title-size font-semibold text-bg">
                        {section.title}
                    </h2>
                    <p className="text-size text-muted-foreground max-w-3xl mx-auto">
                        {section.description}
                    </p>
                </div>

                <div className="grid gap-4 md:grid-cols-3">
                    {section.tactics.map((tactic, index) => (
                        <motion.div
                            key={tactic.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: index * 0.05 }}
                            className="rounded-3xl border bg-white p-6 shadow-sm"
                        >
                            <div className="flex items-center gap-3 mb-4">
                                <div className="iconBudg size-10">
                                    <Shield className="size-5" />
                                </div>
                                <div>
                                    <p className="text-xs uppercase tracking-wide text-muted-foreground">
                                        {tactic.coverage}
                                    </p>
                                    <h3 className="text-lg font-semibold text-bg">
                                        {tactic.name}
                                    </h3>
                                </div>
                            </div>
                            <p className="text-sm text-muted-foreground">
                                {tactic.automation}
                            </p>
                        </motion.div>
                    ))}
                </div>

                <div className="rounded-3xl border border-dashed border-secondary-300 bg-white/80 p-6 text-center text-sm text-muted-foreground flex items-center justify-center gap-2">
                    <Target className="size-5 text-secondary-600" />
                    {section.note}
                </div>
            </div>
        </section>
    );
}
